<template>
  <div v-if="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-1/2 p-6">
      <h2 class="text-3xl font-bold mb-4">Подтверждение</h2>
      <p class="text-base mb-4">Вы действительно хотите {{ this.title }}?</p>
      <div class="h-1/6 py-3 flex gap-6">
        <button
          @click="closeModal"
          class="w-full text-blue-700 text-2xl font-semibold py-4 rounded-2xl hover:bg-blue-200 transition"
        >
          Нет
        </button>
        <button
          @click="confirmModal"
          class="w-full bg-blue-600 text-white text-2xl font-semibold py-4 rounded-2xl hover:bg-blue-700 transition"
        >
          Да
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    confirmModal() {
      this.$emit('confirm');
    },
  },
};
</script>
